import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { ContasReceberConfigRequest } from '../../requests/financas/contas-receber-config.request';
import { ContasReceberConfigResponse } from '../../responses/financas/contas-receber-config.response';

@Injectable({
    providedIn: 'root',
})
export class ContasReceberConfigService extends CommonService {
    private apiUrl = `${environment.urlApiFinancas}ContasReceberConfig`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<ContasReceberConfigResponse> {
        return this.httpClient
            .get<ContasReceberConfigResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public put(request: ContasReceberConfigRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}`;
        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
